import React, { useState } from 'react'
import "./Header.css"

import { Link } from "react-router-dom";


export const Header = () => {

    return (
        <div className="HomePageContainer">
			<div className="NavBarContainer">
			<Link to="/" className="links">
			<div className="school-logo">
			<img width="125" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2FSchool%20logo%20png.png?alt=media&token=b0fa2cfc-9ef3-4f4b-815e-893863c9cb0d" />
			</div>
			</Link>
			<div className="school-info-nav">
			<div className="school-name-1">Sivakasi Nadars</div>
			<div className="school-name-2">Matriculation higher secondary school</div>
			<div className="school-address">26, STC Road, Madurai, Tamil Nadu 625 016</div>
			</div>
			<div className="linksContainer">

			<Link to="/" className="links">
			  <div className="homePageLink">
			   <i style={{fontSize: 30 + 'px'}} class="fas fa-home"></i>
			   <span style={{fontSize: 10 + 'px'}}>Home</span>
			  </div>
			</Link>

			<Link to="/gallery" className="links">
			  <div className="galleryPageLink">
			   <i style={{fontSize: 30 + 'px'}}  class="fas fa-images"></i>
			   <span style={{fontSize: 10 + 'px'}}>Gallery</span>
			  </div>
			</Link>

			<Link to="/about" className="links">
			  <div className="aboutPageLink">	   
			   <i style={{fontSize: 30 + 'px'}} class="fas fa-info-circle"></i>
			   <span style={{fontSize: 10 + 'px'}}>About us</span>
			  </div>
			</Link>

			<Link to="/contact_us" className="links">
			  <div className="contactPageLink">
			   <i style={{fontSize: 30 + 'px'}} class="fas fa-id-card"></i>
			   <span style={{fontSize: 10 + 'px'}}>Contact us</span>
			  </div>
			</Link>
			</div>
			</div>
		</div>
    )
}